import CoreEnums from '@/utils/domain/constants/enumerator';

export const TASK_ITEM_DESCRIPTION = Object.freeze([
  { id: 'global.text.process', key: 'processInstance.process.name' },
  { id: 'global.text.group', key: 'processInstance.process.processGroup.name' },
  { id: 'global.text.user', key: 'processInstance.applicantUser.fullName' },
]);

export const PROCESS_STATUS = Object.freeze({
  0: { name: 'execution', label: 'global.status.running' },
  1: { name: 'approved', label: 'global.status.approved1' },
  2: { name: 'rejected', label: 'global.status.rejected1' },
  3: { name: 'canceled', label: 'global.status.canceled1' },
  4: { name: 'voided', label: 'global.status.voided1' },
  5: { name: 'error', label: 'global.status.error' },
});

export const TASK_STATUS = Object.freeze({
  1: { name: 'complete', label: 'task.status.complete' },
  2: { name: 'approved', label: 'task.status.approved' },
  5: { name: 'execution', label: 'task.status.execution' },
  8: { name: 'signature', label: 'task.status.signature' },
});

export const REQUEST_ITEM_DESCRIPTION = Object.freeze([
  { id: 'global.text.process', key: 'process.name' },
  { id: 'global.text.group', key: 'process.processGroup.name' },
  { id: 'global.text.user', key: 'creator' },
]);

export const BULK_REQUEST_ITEM_DESCRIPTION = Object.freeze([
  { id: 'global.text.process', key: 'process.name' },
  { id: 'global.text.fileName', key: 'fileName' },
  { id: 'global.text.user', key: 'userCreator.fullName' },
]);

export const TYPE_PAGE_FILTER = {
  SEARCH: 'search',
  FILTER: 'filter',
};

export const FORM_FILED_TYPES = {
  [CoreEnums.FormFieldType.Text]: {
    name: 'text',
    label: 'global.field.text',
  },
  [CoreEnums.FormFieldType.TextMultiple]: {
    name: 'textarea',
    label: 'global.field.textMultiple',
  },
  [CoreEnums.FormFieldType.Int]: {
    name: 'int',
    label: 'global.field.int',
  },
  [CoreEnums.FormFieldType.Decimal]: {
    name: 'decimal',
    label: 'global.field.decimal',
  },
  [CoreEnums.FormFieldType.Boolean]: {
    name: 'switch',
    label: 'global.field.boolean',
  },
  [CoreEnums.FormFieldType.DateTime]: {
    name: 'dateTime',
    label: 'global.field.dateTime',
  },
  [CoreEnums.FormFieldType.Date]: {
    name: 'datepicker',
    label: 'global.field.date',
  },
  [CoreEnums.FormFieldType.Time]: {
    name: 'timepicker',
    label: 'global.field.time',
  },
  [CoreEnums.FormFieldType.Choice]: {
    name: 'select',
    label: 'global.field.choice',
  },
  [CoreEnums.FormFieldType.DataBaseRemoteSearch]: {
    name: 'dataBaseRemoteSearch',
    label: 'global.field.dataBaseRemoteSearch',
  },
  [CoreEnums.FormFieldType.DataBaseRemoteList]: {
    name: 'dataBaseRemoteList',
    label: 'global.field.dataBaseRemoteList',
  },
  [CoreEnums.FormFieldType.WebServiceRemoteSearch]: {
    name: 'webServiceRemoteSearch',
    label: 'global.field.webServiceRemoteSearch',
  },
  [CoreEnums.FormFieldType.WebServiceRemoteList]: {
    name: 'webServiceRemoteList',
    label: 'global.field.webServiceRemoteList',
  },
  [CoreEnums.FormFieldType.SelectorUser]: {
    name: 'selectorUser',
    label: 'global.field.selectorUser',
  },
  [CoreEnums.FormFieldType.SelectorPosition]: {
    name: 'selectorPosition',
    label: 'global.field.selectorPosition',
  },
  [CoreEnums.FormFieldType.SelectorUserGroup]: {
    name: 'selectorUserGroup',
    label: 'global.field.selectorUserGroup',
  },
  [CoreEnums.FormFieldType.Table]: {
    name: 'table',
    label: 'global.field.table',
  },
  [CoreEnums.FormFieldType.Attachment]: {
    name: 'upload-dragger',
    label: 'global.field.attachment',
  },
  [CoreEnums.FormFieldType.AutoCalculatedByTableColumn]: {
    name: 'autoCalculatedByTableColumn',
    label: 'global.field.autoCalculatedByTableColumn',
  },
  [CoreEnums.FormFieldType.FieldDynamicEntityList]: {
    name: 'fieldDynamicEntityList',
    label: 'global.field.fieldDynamicEntityList',
  },
  [CoreEnums.FormFieldType.CalculatedByFormula]: {
    name: 'calculatedByFormula',
    label: 'global.field.calculatedByFormula',
  },
  [CoreEnums.FormFieldType.Image]: {
    name: 'upload-dragger-image',
    label: 'global.field.image',
  },
  [CoreEnums.FormFieldType.Photo]: {
    name: 'camera',
    label: 'global.field.photo',
  },
  [CoreEnums.FormFieldType.Signature]: {
    name: 'canvas-draw',
    label: 'global.field.signature',
  },
  [CoreEnums.FormFieldType.GoToAction]: {
    name: 'goToAction',
    label: 'global.field.goToAction',
  },
  [CoreEnums.FormFieldType.Slider]: {
    name: 'slider',
    label: 'global.field.slider',
  },
  [CoreEnums.FormFieldType.FieldDynamicEntitySearch]: {
    name: 'fieldDynamicEntitySearch',
    label: 'global.field.fieldDynamicEntitySearch',
  },
  [CoreEnums.FormFieldType.SelectorArea]: {
    name: 'selectorArea',
    label: 'global.field.selectorArea',
  },
  [CoreEnums.FormFieldType.RadioGroup]: {
    name: 'radio-group',
    label: 'global.field.radioGroup',
  },
  [CoreEnums.FormFieldType.CheckGroup]: {
    name: 'check-group',
    label: 'global.field.checkGroup',
  },
  [CoreEnums.FormFieldType.Url]: {
    name: 'url',
    label: 'global.field.url',
  },
  [CoreEnums.FormFieldType.Location]: {
    name: 'location',
    label: 'global.field.location',
  },
  [CoreEnums.FormFieldType.InternalEntity]: {
    name: 'internalEntity',
    label: 'global.field.internalEntity',
  },
};
export const TYPES_OF_EXTRA_USER_FIELDS = {
  [CoreEnums.FormFieldType.Text]: {
    name: 'text',
    label: 'global.field.text',
  },

  [CoreEnums.FormFieldType.Int]: {
    name: 'int',
    label: 'global.field.intNumber',
  },
  [CoreEnums.FormFieldType.Decimal]: {
    name: 'decimal',
    label: 'global.field.decimalNumber',
  },
  [CoreEnums.FormFieldType.Boolean]: {
    name: 'switch',
    label: 'global.field.yesNo',
  },
  [CoreEnums.FormFieldType.DateTime]: {
    name: 'dateTime',
    label: 'global.field.dateTime',
  },
  [CoreEnums.FormFieldType.Date]: {
    name: 'datepicker',
    label: 'global.field.date',
  },
  [CoreEnums.FormFieldType.Time]: {
    name: 'timepicker',
    label: 'global.field.time',
  },
  [CoreEnums.FormFieldType.Choice]: {
    name: 'select',
    label: 'global.field.choice',
  },

  [CoreEnums.FormFieldType.SelectorUser]: {
    name: 'selectorUser',
    label: 'global.field.selectorUser',
  },

  [CoreEnums.FormFieldType.SelectorUserGroup]: {
    name: 'selectorUserGroup',
    label: 'global.field.selectorUserGroup',
  },

  [CoreEnums.FormFieldType.Attachment]: {
    name: 'upload-dragger',
    label: 'global.field.attachment',
  },

  [CoreEnums.FormFieldType.FieldDynamicEntityList]: {
    name: 'fieldDynamicEntityList',
    label: 'global.field.fieldDynamicEntityList',
  },

  [CoreEnums.FormFieldType.Image]: {
    name: 'upload-dragger-image',
    label: 'global.field.image',
  },
  [CoreEnums.FormFieldType.Photo]: {
    name: 'camera',
    label: 'global.field.photo',
  },

  [CoreEnums.FormFieldType.FieldDynamicEntitySearch]: {
    name: 'fieldDynamicEntitySearch',
    label: 'global.field.fieldDynamicEntitySearch',
  },

  [CoreEnums.FormFieldType.RadioGroup]: {
    name: 'radio-group',
    label: 'global.field.radioGroup',
  },

  [CoreEnums.FormFieldType.CheckGroup]: {
    name: 'check-group',
    label: 'global.field.checkGroup',
  },

  [CoreEnums.FormFieldType.Url]: {
    name: 'url',
    label: 'global.field.url',
  },
  [CoreEnums.FormFieldType.Location]: {
    name: 'location',
    label: 'global.field.location',
  },
  [CoreEnums.FormFieldType.Email]: {
    name: 'email',
    label: 'global.field.email',
  },
  [CoreEnums.FormFieldType.Password]: {
    name: 'password',
    label: 'global.field.password',
  },
};

export const RESPONSE_GROUPING_TYPE = {
  [CoreEnums.ResponseGroupingType.None]: {
    name: 'none',
    label: 'global.field.none',
  },
  [CoreEnums.ResponseGroupingType.Value]: {
    name: 'value',
    label: 'global.field.value',
  },
  [CoreEnums.ResponseGroupingType.DisplayText]: {
    name: 'displayText',
    label: 'global.field.displayText',
  },
};

export const COLUMN_ORDER_DIRECTION = {
  [CoreEnums.ColumnOrderDirection.Ascending]: {
    name: 'ascending',
    label: 'global.field.ascending',
  },
  [CoreEnums.ColumnOrderDirection.Descending]: {
    name: 'descending',
    label: 'global.field.descending',
  },
};

export const ENVIRONMENT_CLASSIFICATION = Object.freeze({
  [CoreEnums.EnvironmentClassification.Development]: {
    name: 'development',
    label: 'global.field.development',
  },
  [CoreEnums.EnvironmentClassification.Testing]: {
    name: 'testing',
    label: 'global.field.testing',
  },
  [CoreEnums.EnvironmentClassification.Production]: {
    name: 'production',
    label: 'global.field.production',
  },
});

export const LOGICAL_OPERATOR = Object.freeze({
  [CoreEnums.LogicalOperator.Or]: {
    name: 'or',
    label: 'global.field.or',
  },
  [CoreEnums.LogicalOperator.And]: {
    name: 'and',
    label: 'global.field.and',
  },
});
